import { SESSION_SANDBOX_CAPACITY_WAIT_REASON } from "../shared/session-status-constants";

/** Parked until an Ares machine frees up: it resumes itself and owes no human anything. */
export function isSandboxCapacityPark(input: {
  status: string;
  statusReason?: string | null;
}): boolean {
  return (
    input.status === "waiting_human" &&
    input.statusReason === SESSION_SANDBOX_CAPACITY_WAIT_REASON
  );
}
